import { type AppActions, type AppState, HIDE_SESSION_EXPIRED_DIALOG } from './types';

const initialState: AppState = {
    sessionExpiredAcknowledged: false,
};

export const appReducer = (state: AppState | undefined, action: AppActions): AppState => {
    const currentState = state ?? initialState;

    if (action.type === HIDE_SESSION_EXPIRED_DIALOG) {
        return {
            ...currentState,
            sessionExpiredAcknowledged: true,
        };
    }
    return currentState;
};
